module.exports = __webpack_public_path__ + "img/safe_camical_02.26eff4cb.jpg";